import { buttonsAdapter } from './buttonsAdapter'
import { Element } from '@/apollo/composition-functions'

type DataProps = {
  formTitleSecondPart?: string
  formTitleSecondPartEng?: string
  policyAccept?: string
  sectionMainTitle?: string
  sectionMainTitleEng?: string
  sectionSideTitle?: string
  sectionSideTitleEng?: string
  sectionId?: string
  sectionDescription?: string
  sectionDate?: string
  sectionButtonsAlignment?: string
  sectionButtons?: Element[] | null
  sectionFormDescriptionSecondPart?: string
  sectionFormDescriptionSecondPartEng?: string
  switchLangLink?: string
  switchLangLinkEng?: string
  switchLangLinkText?: string
  switchLangLinkTextEng?: string | null
  langType?: string
  linkText?: string
  linkUrl?: string
  sectionBackground?: string
  offsetDesktop?: string | null
  offsetMobile?: string | null
  foundText?: string
  notFoundText?: string
  startOptionsProp?: string
  cardBotFound?: string
}

export const sectionDataAdapter = (data: DataProps) => {
  const {
    formTitleSecondPart,
    formTitleSecondPartEng,
    policyAccept,
    sectionMainTitle,
    sectionMainTitleEng,
    sectionSideTitle,
    sectionSideTitleEng,
    sectionId,
    sectionDescription,
    sectionDate,
    sectionButtonsAlignment,
    sectionButtons,
    sectionFormDescriptionSecondPart,
    sectionFormDescriptionSecondPartEng,
    switchLangLink,
    switchLangLinkEng,
    switchLangLinkText,
    switchLangLinkTextEng,
    langType,
    linkText,
    linkUrl,
    sectionBackground,
    offsetDesktop = null,
    offsetMobile = null,
    foundText,
    notFoundText,
    startOptionsProp,
    cardBotFound,
  } = data

  // Обработка offset с проверкой типа
  const parseOffset = (value: string | null | undefined): number[] | null => {
    if (!value) return null
    if (/^\d+,\d+$/.test(value)) {
      return value.split(',').map(Number)
    }
    return null
  }

  return {
    formTitleSecondPart,
    formTitleSecondPartEng,
    policyAccept,
    sectionMainTitle,
    sectionMainTitleEng,
    sectionSideTitle,
    sectionSideTitleEng,
    sectionId,
    sectionDescription,
    sectionDate,
    sectionButtonsAlignment,
    sectionBackground,
    sectionButtons: buttonsAdapter(sectionButtons),
    sectionLink: linkText
      ? {
          value: linkText,
          link: linkUrl || '#',
          arrowType: 'arrow-right',
        }
      : null,
    sectionFormDescriptionSecondPart,
    sectionFormDescriptionSecondPartEng,
    switchLangLink,
    switchLangLinkEng,
    switchLangLinkText,
    switchLangLinkTextEng,
    offset: {
      desktop: parseOffset(offsetDesktop),
      mobile: parseOffset(offsetMobile),
    },
    langType,
    foundText,
    notFoundText,
    startOptionsProp,
    cardBotFound,
  }
}
